// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getContent,
  getTitle,
} from '@leasen_nl/listo/src/store/configuratorSettings/selectors';
import { ACFFormidable } from '@leasen_nl/listo/src/components/formidable';
import Modal from '@leasen_nl/listo/src/components/modal';
import Description from './atoms/description';


type OwnProps = {|
  closeModal: Function,
  isOpen: boolean,
  saveCompositionForm: any,
|};

type StateProps = {|
  content: string,
  title: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

class SaveConfigModal extends Component<Props> {
  handleClose() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      content,
      isOpen,
      title,
      saveCompositionForm,
    } = this.props;

    return (
      <Modal
        align="center"
        ariaLabel="Form to store current configuration"
        onClose={() => this.handleClose()}
        isOpen={isOpen}
        title={title}
        closeOnOverlayClick
        size="medium"
      >
        {/* eslint-disable react/no-danger */}
        <Description dangerouslySetInnerHTML={{ __html: content }} />
        {/* eslint-enable react/no-danger */}
        <ACFFormidable form_data={saveCompositionForm} />
      </Modal>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  content: getContent(state),
  title: getTitle(state),
});


export default compose(
  connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps),
)(SaveConfigModal);
